import { navLinks } from '@/mocks/drama';

export default function Footer() {
  return (
    <footer className="bg-primary-950 text-background-100">
      <div className="mx-auto max-w-7xl px-4 py-14 md:px-6 md:py-16">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-2 lg:grid-cols-4">
          <div className="lg:col-span-2">
            <div className="flex items-center gap-2">
              <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary-500 text-background-50">
                <i className="ri-fire-line text-lg" />
              </span>
              <span className="font-heading text-lg font-bold tracking-wide text-white">欲望的诱惑</span>
            </div>
            <p className="mt-4 max-w-md text-sm leading-relaxed text-background-200/80">
              一个围绕《欲望的诱惑》整理演员表、主演是谁、角色介绍与人物关系的资料页，
              帮助你在追剧之前快速了解人物与剧情脉络。
            </p>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold tracking-wide text-white">站内导航</h4>
            <ul className="mt-4 space-y-2">
              {navLinks.map((link) => (
                <li key={link.href}>
                  <a
                    href={link.href}
                    className="text-sm text-background-200/75 transition-colors hover:text-accent-300"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold tracking-wide text-white">资料说明</h4>
            <p className="mt-4 text-sm leading-relaxed text-background-200/75">
              本页内容依据公开剧集信息整理，用于角色与人物关系的查询参考。剧集属于普法栏目剧形态，
              演员与单元信息以平台实际展示为准。
            </p>
          </div>
        </div>

        <div className="mt-12 flex flex-col gap-3 border-t border-white/10 pt-6 text-xs text-background-200/60 sm:flex-row sm:items-center sm:justify-between">
          <span>© {new Date().getFullYear()} 欲望的诱惑 · 角色资料整理页</span>
          <span className="inline-flex items-center gap-1.5">
            <i className="ri-eye-line" />
            仅作内容展示，不含任何真实提交或账号功能
          </span>
        </div>
      </div>
    </footer>
  );
}